import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Breakpoints, Classes, Events } from '../global/constants';
import { wait } from '../global/helpers';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.menu.min.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
						(!$('.home-introduction-section').hasClass(Classes.animating) && self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					}
				}
			});
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 90%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- Home Introduction ----------

	$('.home-introduction-section').each(function() {

		const slides = $(this).find('.home-introduction-slide');
		const logo = $(this).find('.logo-baseline');

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: () => -1,
					end: () => 'bottom bottom',
					scrub: true,
					invalidateOnRefresh: true,
					toggleClass: Classes.animating,
				}
			});
		});

		slides.each(function(index) {

			const type = this.dataset.type;
			const slug = this.dataset.slug;
			const isFirstProject = (index === 1);
			const isLastProject = (index === slides.length - 1);

			Animations.global.push(() => {

				const onEnter = () => {

					logo.find('text').removeClass(Classes.active);

					if(type === 'content') {
						logo.find('[data-slug="default"]').addClass(Classes.active);
					}
					else if(type === 'project') {
						logo.find('[data-slug="' + slug + '"]').addClass(Classes.active);
					}
				};

				gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: () => 'top 75%',
						end: () => 'bottom 25%',
						toggleClass: Classes.active,
						scrub: true,
						invalidateOnRefresh: true,
						onEnter: onEnter,
						onEnterBack: onEnter,
					}
				});
			});

			if(type === 'content') {

				const content = this.querySelector('.home-introduction-slide-inner');

				let contentAnimation = null;

				Animations.mobile.min.push(() => {

					if(contentAnimation) {
						contentAnimation.kill();
					}

					contentAnimation = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: () => 'top top',
							end: () => 'bottom top',
							scrub: true,
							invalidateOnRefresh: true,
						}
					}).to(content, {
						opacity: 0,
						yPercent: -75,
						filter: 'blur(10rem)',
						ease: 'none',
					});
				});

				Animations.mobile.max.push(() => {

					if(contentAnimation) {
						contentAnimation.kill();
					}

					contentAnimation = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: () => 'top top',
							end: () => 'bottom center',
							scrub: true,
							invalidateOnRefresh: true,
						}
					}).to(content, {
						opacity: 0,
						yPercent: -10,
						ease: 'none',
					});
				});
			}
			else if(type === 'project') {

				// Project

				const project = this.querySelector('.project');

				Animations.global.push(() => {

					gsap.set(project, {
						x: 360,
						y: 89,
						z: 178,
						rotateX: 15,
						rotateY: -15,
						rotateZ: -15,
						transform: 'perspective(40rem)',
					});

					gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: () => 'top bottom',
							end: () => 'bottom top',
							scrub: true,
							invalidateOnRefresh: true,
						}
					}).to(project, {
						x: -360,
						y: -89,
						z: -178,
						rotateX: -15,
						rotateY: 15,
						rotateZ: 15,
						ease: 'none'
					})
				});

				// Sentence

				const sentenceContent = this.querySelector('.introduction');
				const sentenceText = sentenceContent.querySelector('.scrolling-text');

				Animations.global.push(() => {

					const sentenceScroll = gsap.to(sentenceText, {
						duration: 10,
						ease: 'none',
						x: "-=20%",
						repeat: -1
					});
					const sentenceScrollClamp = gsap.utils.clamp(-5, 5);

					let sentenceSkew = { skew: 0 };
					const sentenceSkewSetter = gsap.quickSetter(sentenceText, "skewX", "deg");
					const sentenceSkewClamp = gsap.utils.clamp(-10, 10);

					gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: () => 'top bottom',
							end: () => 'bottom top',
							scrub: true,
							invalidateOnRefresh: true,
							onUpdate: (self) => {

								sentenceScroll.timeScale(sentenceScrollClamp(self.getVelocity() / 50));

								gsap.to(sentenceScroll, {
									overwrite: true,
									timeScale: 1
								});

								let skew = sentenceSkewClamp(self.getVelocity() / 200);

								if(Math.abs(skew) > Math.abs(sentenceSkew.skew)) {

									sentenceSkew.skew = skew;

									gsap.to(sentenceSkew, {
										skew: 0,
										duration: 1,
										overwrite: true,
										onUpdate: () => sentenceSkewSetter(sentenceSkew.skew)
									});
								}
							},
						}
					});
				});

				let sentenceBlur = null;

				Animations.mobile.min.push(() => {

					if(sentenceBlur) {
						sentenceBlur.kill();
					}

					gsap.set(sentenceText, {
						filter: 'blur(5rem)',
						opacity: 0,
						transformOrigin: 'right center',
					});

					sentenceBlur = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: () => 'top center',
							end: () => 'bottom center',
							scrub: true,
							invalidateOnRefresh: true,
						}
					}).to(sentenceText, {
						opacity: 1,
						filter: 'blur(0rem)',
						ease: 'expo.out',
					}).to(sentenceText, {
						opacity: 0,
						filter: 'blur(5rem)',
						ease: 'expo.in',
					});
				});

				Animations.mobile.max.push(() => {

					if(sentenceBlur) {
						sentenceBlur.kill();
					}

					gsap.set(sentenceText, {
						opacity: 0,
						filter: null,
						transformOrigin: "right center",
					});

					sentenceBlur = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: () => 'top center',
							end: () => 'bottom center',
							scrub: true,
							invalidateOnRefresh: true,
						}
					}).to(sentenceText, {
						opacity: 1,
						ease: 'none',
					}).to(sentenceText, {
						opacity: 0,
						ease: 'none',
					});
				});
			}
		});
	});

	// ---------- Introduction ----------

	$('.introduction-section.full').each(function() {

		const content = this.querySelector('.content-column');

		let contentAnimation = null;

		Animations.mobile.min.push(() => {

			if(contentAnimation) {
				contentAnimation.kill();
			}

			contentAnimation = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: () => 'top top',
					end: () => 'bottom center',
					scrub: true,
					invalidateOnRefresh: true,
				}
			}).to(content, {
				opacity: 0,
				yPercent: 25,
				filter: 'blur(10rem)',
				ease: 'none',
			});
		});

		Animations.mobile.max.push(() => {

			if(contentAnimation) {
				contentAnimation.kill();
			}

			contentAnimation = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: () => 'top top',
					end: () => 'bottom center',
					scrub: true,
					invalidateOnRefresh: true,
				}
			}).to(content, {
				opacity: 0,
				yPercent: -10,
				ease: 'none',
			});
		});
	});

	// ---------- Testimonials ----------

	$('.testimonials-section').each(function() {

		const content = this.querySelector(':scope .section-content');
		const columns = this.querySelector(':scope .section-columns');
		let testimonialsAnimation = null;

		if(content && columns) {

			const contentColumns = gsap.utils.toArray('.content-column', columns);

			Animations.mobile.max.push(() => {

				if(testimonialsAnimation) {
					testimonialsAnimation.kill();
				}

				const contentWidth = () => contentColumns.reduce((val, section) => val + section.offsetWidth, 0);
				let maxWidth = 0;

				const refreshValues = () => {
					maxWidth = contentWidth();
				};

				refreshValues();
				ScrollTrigger.addEventListener("refreshInit", refreshValues);

				testimonialsAnimation = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						pin: true,
						scrub: true,
						invalidateOnRefresh: true,
						start: 'top 10%',
						end: () => '+=' + maxWidth,
					},
				});

				testimonialsAnimation.to(contentColumns, {
					x: () => window.innerWidth - maxWidth,
					ease: 'none'
				});
			});

			Animations.mobile.min.push(() => {

				if(testimonialsAnimation) {
					testimonialsAnimation.kill();
				}

				const contentHeight = () => contentColumns.reduce((val, section) => val + section.offsetHeight, 0);
				let maxHeight = 0;

				const refreshValues = () => {
					maxHeight = contentHeight();
				};

				refreshValues();
				ScrollTrigger.addEventListener("refreshInit", refreshValues);

				testimonialsAnimation = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						pin: true,
						pinSpacing: false,
						scrub: true,
						invalidateOnRefresh: true,
						start: 'top 33%',
						end: () => "+=" + (maxHeight - content.offsetHeight),
					}
				});

				testimonialsAnimation.to(contentColumns, {
					y: () => -(maxHeight - content.offsetHeight),
					ease: 'none'
				});
			});
		}
	});

	// ---------- We Are ----------

	$('.we-are-section').each(function() {

		const content = this.querySelector(':scope .section-content');
		const columns = this.querySelector(':scope .section-columns');
		let weAreAnimation = null;

		if(content && columns) {

			const contentColumns = gsap.utils.toArray('.content-column', columns);

			Animations.global.push(() => {

				if(weAreAnimation) {
					weAreAnimation.kill();
				}

				const contentHeight = () => contentColumns.reduce((val, section) => val + section.offsetHeight, 0);
				let maxHeight = 0;

				const refreshValues = () => {

					maxHeight = contentHeight();

					contentColumns.forEach(async column => {

						const content = column.querySelector('.content');

						gsap.set(column, {
							position: 'static',
							height: column.offsetHeight,
							width: column.offsetWidth,
						});

						await wait(100);

						gsap.set(content, {
							position: 'absolute',
							y: '25vh',
							top: 0,
							left: 0,
							height: column.offsetHeight,
							width: '100%',
							opacity: 0,
						});
					});
				};

				refreshValues();
				ScrollTrigger.addEventListener("refreshInit", refreshValues);

				weAreAnimation = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						pin: true,
						pinSpacing: false,
						scrub: true,
						invalidateOnRefresh: true,
						start: () => (window.innerWidth < Breakpoints.mobile) ? 'top 25%' : 'top 35%',
						end: () => '+=' + (maxHeight - content.offsetHeight),
					}
				});

				contentColumns.forEach((column, index, array) => {
					const content = column.querySelector('.content');

					weAreAnimation.to(content, {
						y: '0vh',
						opacity: 1,
						ease: 'none',
					});

					if(index < array.length - 1) {

						weAreAnimation.to(content, {
							opacity: 0,
							ease: 'none',
						});
					}
				})
			});
		}
	});

	// ---------- Projects ----------

	$('.projects-section').each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: () => -1,
					end: () => 'bottom bottom',
					scrub: true,
					invalidateOnRefresh: true,
					toggleClass: Classes.animating,
				}
			});
		});

		// Introduction

		const introduction = this.querySelector('.section-content');
		const introductionText = introduction.querySelector('.scrolling-text');

		const introductionScroll = gsap.to(introductionText, {
			duration: 10,
			ease: 'none',
			x: "-=20%",
			repeat: -1
		});
		const introductionScrollClamp = gsap.utils.clamp(-5, 5);

		let introductionSkew = { skew: 0 };
		const introductionSkewSetter = gsap.quickSetter(introductionText, "skewX", "deg");
		const introductionSkewClamp = gsap.utils.clamp(-10, 10);

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: () => 'top bottom',
					end: () => 'bottom top',
					scrub: true,
					invalidateOnRefresh: true,
					onUpdate: (self) => {

						introductionScroll.timeScale(introductionScrollClamp(self.getVelocity() / 50));

						gsap.to(introductionScroll, {
							overwrite: true,
							timeScale: 1
						});

						let skew = introductionSkewClamp(self.getVelocity() / 200);

						if(Math.abs(skew) > Math.abs(introductionSkew.skew)) {

							introductionSkew.skew = skew;

							gsap.to(introductionSkew, {
								skew: 0,
								duration: 1,
								overwrite: true,
								onUpdate: () => introductionSkewSetter(introductionSkew.skew)
							});
						}
					},
				}
			});
		});

		// Projects

		const projects = $(this).find('.content-column');

		projects.each(function() {

			const content = this.querySelector('.content')
			const project = content.querySelector('.project');

			let projectsAnimation = null;

			Animations.sm.max.push(() => {

				if(projectsAnimation) {
					projectsAnimation.kill();
				}

				projectsAnimation = gsap.timeline().set(project, {
					transformOrigin: `300% 50%`
				}, 'start').to(project, {
					ease: 'none',
					startAt: { rotationZ: -30 },
					rotationZ: 30,
					scrollTrigger: {
						trigger: content,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true,
					}
				}, 'start');
			});

			Animations.sm.min.push(() => {

				if(projectsAnimation) {
					projectsAnimation.kill();
				}

				projectsAnimation = gsap.timeline().set(project, {
					transformOrigin: `300% 50%`
				}, 'start').to(project, {
					ease: 'none',
					startAt: { rotationZ: -15 },
					rotationZ: 15,
					scrollTrigger: {
						trigger: content,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true,
					}
				}, 'start').to(content, {
					ease: 'none',
					y: gsap.utils.random(-15, 15) + 'vw',
					scrollTrigger: {
						trigger: content,
						start: "top bottom",
						end: "top top",
						scrub: true,
						invalidateOnRefresh: true,
					}
				}, 'start');
			});
		});
	});

	$('.image-fullwidth-section, .image-boxed-section').each(function() {

		Animations.global.push(() => {

			if(this.classList.contains('parallax')) {

				const image = this.querySelectorAll('.content-column');

				if(image) {

					gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
							invalidateOnRefresh: true,
						},
					}).fromTo(
						image,
						{ y: () => '-30vh', ease: 'none' },
						{ y: () => '30vh', ease: 'none' }
					);
				}
			}
			else {

				const paths = gsap.utils.toArray('path.svg-path-anim', this);

				if(paths) {

					paths.forEach(el => {
						const svgEl = el.closest('svg');
						const pathTo = el.dataset.pathTo;

						gsap.timeline({
							scrollTrigger: {
								trigger: svgEl,
								start: 'top bottom',
								end: 'bottom top',
								scrub: true,
								invalidateOnRefresh: true,
							}
						}).to(el, {
							attr: { d: pathTo },
							ease: 'none',
						});
					});
				}
			}
		});
	});

	$('.archive-posts').each(function() {
		const section = this;
		const imageColumns = section.querySelectorAll('.image-column');

		Animations.mobile.min.push(() => {

			const rhythm = [20, 40, 20, 50, 30];

			imageColumns.forEach((column, index) => {
				const rhythmIndex = index % rhythm.length;
				const distance = rhythm[rhythmIndex];

				gsap.fromTo(column,
					{ y: `${distance}vh` },
					{
						y: `-${distance}vh`,
						ease: 'ease-in',
						scrollTrigger: {
							trigger: section,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
							invalidateOnRefresh: true
						}
					}
				);
			});
		});
	});


};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
